import React from 'react';
import PropTypes from 'prop-types';
import { SupportedBrowserEnum } from '../DownloadOverlayConstants';

const DownloadOverlayText = (props) => {
  let text = '';

  switch (props.browserType) {
    case SupportedBrowserEnum.FIREFOX:
      text = 'Click the blue arrow for your downloaded document.';
      break;
    case SupportedBrowserEnum.MSIE:
    default:
      // currently we don't show any download overlay text for remaining browsers
      break;
  }

  const styles = {
    color: '#fff',
    fontSize: 25,
    lineHeight: '25px',
    textAlign: 'center',
  };

  return (
    <p className={'download-overlay-text'} style={styles}>
      {text}
    </p>
  );
};

DownloadOverlayText.propTypes = {
  browserType: PropTypes.oneOf([
    SupportedBrowserEnum.FIREFOX,
    SupportedBrowserEnum.MSIE,
  ]).isRequired,
};

export default DownloadOverlayText;




// WEBPACK FOOTER //
// ./src-react/download-overlay/components/DownloadOverlayText.jsx